import seoMeta from './seoMeta.json';

// Resolve title/description/image/siteName for a country + pathname.
export const resolvePageMeta = (countryCode, pathname) => {
  const cfg = seoMeta[countryCode] || seoMeta.DEFAULT;
  const path = (pathname || '/').replace(/\/+$/, '') || '/';
  const page = cfg.pages[path] || cfg.default;
  return {
    siteName: cfg.siteName,
    domain: cfg.domain,
    image: cfg.image,
    title: page.title,
    description: page.description,
  };
};

export const PUBLIC_META_ROUTES = Object.keys(seoMeta.AU.pages);
